import { cn as e } from "../shared/utils.js";
import { Badge as t } from "../badge/badge.js";
import { OverflowProvider as n } from "../shared/overflow/overflow-context.js";
import { useOverflowContainer as r } from "../shared/overflow/use-overflow-container.js";
import { useOverflowItem as i } from "../shared/overflow/use-overflow-item.js";
import { useOverflowMenu as a } from "../shared/overflow/use-overflow-menu.js";
import { Checkbox as o } from "../checkbox/primitive/index.js";
import { ComboboxVirtualizedList as s, ComboboxVirtualizerContext as c, scrollVirtualizedHighlight as l } from "./virtualized-list.js";
import { CheckIcon as u, PlusCircleIcon as d, XCircleFillIcon as f, XCloseIcon as p } from "@systemeio/icons";
import { createContext as m, forwardRef as h, useCallback as g, useContext as _, useId as ee, useRef as te } from "react";
import { Fragment as ne, jsx as v, jsxs as y } from "react/jsx-runtime";
import { cva as b } from "class-variance-authority";
import { Field as re } from "@base-ui/react/field";
import { Combobox as x } from "@base-ui/react/combobox";
//#region src/combobox/combobox-primitive.tsx
var S = m(null), C = m(void 0), w = m(!1);
function T({ max: e, children: t, id: n, onItemHighlighted: r, ...i }) {
	let a = ee(), o = n ?? a, s = te(null), u = te(null), d = g((e, t) => {
		r?.(e, t), l(u.current, t);
	}, [r]);
	return /* @__PURE__ */ v(C.Provider, {
		value: o,
		children: /* @__PURE__ */ v(S.Provider, {
			value: s,
			children: /* @__PURE__ */ v(c.Provider, {
				value: u,
				children: /* @__PURE__ */ v(w.Provider, {
					value: !!i.multiple,
					children: /* @__PURE__ */ v(x.Root, {
						id: o,
						onItemHighlighted: d,
						...i,
						children: t
					})
				})
			})
		})
	});
}
var E = b([
	"self-center group-data-[size=sm]/combobox-group:min-h-6 group-data-[size=sm]/combobox-group:px-1.5 group-data-[size=sm]/combobox-group:text-sm",
	"in-data-[overflow-mode=expanded]:max-w-full in-data-[overflow-mode=expanded]:rounded-[14px] group-data-[size=sm]/combobox-group:in-data-[overflow-mode=expanded]:rounded-xl in-data-[overflow-mode=expanded]:text-start in-data-[overflow-mode=expanded]:wrap-anywhere in-data-[overflow-mode=expanded]:whitespace-normal",
	"outline-none focus:ring-2 focus:ring-field-border-active focus:ring-offset-1",
	"[&>svg:not([class*=size-])]:size-4"
], {
	variants: { variant: {
		tag: "",
		ghost: "inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-base font-normal whitespace-nowrap bg-transparent text-text-primary"
	} },
	defaultVariants: { variant: "tag" }
}), D = b(["flex size-6 shrink-0 cursor-pointer items-center justify-center rounded-full p-1 -m-1 outline-none [--icon-color-tertiary:var(--color-bg-primary)] [&>svg]:size-4"], {
	variants: { variant: {
		tag: "text-inherit hover:bg-current/10",
		ghost: "text-text-primary hover:bg-text-primary/10"
	} },
	defaultVariants: { variant: "tag" }
}), O = b([
	"group/combobox-group flex w-full min-w-0 items-center rounded-md border border-field-border bg-field-bg-primary text-text-primary outline-none transition-base text-base",
	"data-[size=md]:px-3 data-[size=sm]:px-2",
	"placeholder:text-text-tertiary",
	"data-popup-open:border-field-border-active data-popup-open:shadow-field-border-active",
	"focus-within:border-field-border-active focus-within:shadow-field-border-active",
	"hover:border-field-border-hover",
	"data-disabled:bg-field-bg-disabled data-disabled:text-text-disabled data-disabled:cursor-not-allowed",
	"data-invalid:border-field-border-error data-invalid:shadow-field-border-error",
	"data-invalid:focus-within:border-field-border-error data-invalid:focus-within:shadow-field-border-error",
	"data-warning:border-border-warning data-warning:shadow-field-border-warning",
	"data-warning:focus-within:border-border-warning data-warning:focus-within:shadow-field-border-warning",
	"data-warning:data-popup-open:border-border-warning data-warning:data-popup-open:shadow-field-border-warning",
	"has-data-[overflow-mode=expanded]:h-auto has-data-[overflow-mode=expanded]:items-start",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: { size: {
		sm: "h-8 min-h-8 py-1.5 has-data-[overflow-mode=collapsed]:py-[calc(0.25rem-1px)] has-data-[overflow-mode=expanded]:min-h-8 has-data-[overflow-mode=expanded]:py-[calc(0.25rem-1px)]",
		md: "h-10 min-h-10 py-2.5 has-data-[overflow-mode=collapsed]:py-[calc(0.375rem-1px)] has-data-[overflow-mode=expanded]:min-h-10 has-data-[overflow-mode=expanded]:py-[calc(0.375rem-1px)]"
	} },
	defaultVariants: { size: "md" }
}), k = b("text-text-primary data-placeholder:text-text-tertiary group-data-disabled/combobox-group:text-text-disabled min-w-0 flex-1 px-0.75 text-base", { variants: { element: {
	input: "placeholder:text-text-tertiary group-data-disabled/combobox-group:placeholder:text-text-disabled h-5 border-0 bg-transparent outline-none",
	value: "line-clamp-1 h-5 text-left"
} } }), A = b("text-field-icon group-data-disabled/combobox-group:text-text-disabled flex size-5 shrink-0 items-center justify-center [&>svg]:size-5 [&>svg]:transition-transform [&>svg]:duration-200 [&>svg]:ease-out"), j = h(({ className: t, size: n = "md", ...r }, i) => {
	let a = _(S), o = g((e) => {
		a && (a.current = e), typeof i == "function" ? i(e) : i && (i.current = e);
	}, [a, i]);
	return /* @__PURE__ */ v("div", {
		"data-slot": "combobox-input-group-shell",
		"data-testid": "combobox-input-group-shell",
		"data-size": n,
		className: "relative w-full min-w-0",
		children: /* @__PURE__ */ v(x.InputGroup, {
			ref: o,
			"data-slot": "combobox-input-group",
			"data-testid": "combobox-input-group",
			"data-size": n,
			className: e(O({ size: n }), t),
			...r
		})
	});
}), M = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Input, {
	ref: r,
	"data-slot": "combobox-input",
	"data-testid": "combobox-input",
	className: e(k({ element: "input" }), t),
	...n
})), N = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Trigger, {
	ref: r,
	"data-slot": "combobox-trigger",
	"data-testid": "combobox-trigger",
	className: e(A(), "data-popup-open:[&_svg]:rotate-180", t),
	...n
})), P = h(({ className: t, ...n }, r) => {
	let { children: i, placeholder: a } = n, o = /* @__PURE__ */ v(x.Value, {
		...n,
		children: i
	});
	return typeof i == "function" ? o : /* @__PURE__ */ v("span", {
		ref: r,
		"data-slot": "combobox-value",
		"data-testid": "combobox-value",
		className: e(k({ element: "value" }), t),
		children: o
	});
}), F = h(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ v(x.Clear, {
	ref: i,
	"data-slot": "combobox-clear",
	"data-testid": "combobox-clear",
	className: e("text-field-icon hover:text-icon-primary flex size-5 shrink-0 cursor-pointer items-center justify-center outline-none [&>svg]:size-5", t),
	...r,
	children: n ?? /* @__PURE__ */ v(p, {})
})), ie = x.Portal, I = h(({ className: t, sideOffset: n = 4, anchor: r, ...i }, a) => {
	let o = _(S), s = r ?? o?.current ?? void 0;
	return /* @__PURE__ */ v(x.Positioner, {
		ref: a,
		"data-slot": "combobox-positioner",
		"data-testid": "combobox-positioner",
		sideOffset: n,
		anchor: s,
		className: e("z-50 outline-none", t),
		...i
	});
}), L = h(({ className: t, children: n, style: r, ...i }, a) => /* @__PURE__ */ v(x.Popup, {
	ref: a,
	"data-slot": "combobox-popup",
	"data-testid": "combobox-popup",
	style: r,
	className: e("bg-bg-primary text-text-primary border-border-100 shadow-1 rounded-md border py-1 outline-none", "flex max-h-[min(268px,var(--available-height))] w-(--anchor-width) min-w-[160px] flex-col overflow-hidden", "data-starting-style:scale-95 data-starting-style:opacity-0", "data-ending-style:scale-95 data-ending-style:opacity-0", "origin-(--transform-origin) transition-[transform,opacity] duration-100 ease-out", t),
	...i,
	children: n ?? /* @__PURE__ */ v(u, {})
})), R = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.List, {
	ref: r,
	"data-slot": "combobox-list",
	"data-testid": "combobox-list",
	className: e("min-h-0 flex-1 overflow-y-auto overscroll-contain", "*:data-[slot='combobox-group']:flex *:data-[slot='combobox-group']:flex-col *:data-[slot='combobox-group']:gap-0", t),
	...n
})), ae = b([
	"group relative flex w-full min-w-0 cursor-pointer flex-row items-center px-4 py-3 text-base outline-none select-none",
	"data-disabled:text-text-disabled data-disabled:cursor-not-allowed",
	"[&>svg:not([class*=size-])]:size-5"
], {
	variants: {
		create: {
			true: "text-text-link gap-1",
			false: "text-text-primary hover:bg-bg-tertiary data-highlighted:bg-bg-tertiary data-selected:bg-bg-accent-light"
		},
		multiple: {
			true: "gap-2",
			false: "gap-1"
		}
	},
	compoundVariants: [{
		create: !0,
		multiple: !0,
		class: "gap-1"
	}],
	defaultVariants: {
		create: !1,
		multiple: !1
	}
}), z = h(({ className: t, render: n, ...r }, i) => {
	let a = _(w);
	return /* @__PURE__ */ v(x.Item, {
		ref: i,
		"data-slot": "combobox-item",
		"data-testid": "combobox-item",
		render: n,
		className: e(!n && ae({ multiple: a }), n && "w-full justify-start", t),
		...r
	});
}), B = h(({ className: t, truncate: n = !0, ...r }, i) => /* @__PURE__ */ v("div", {
	ref: i,
	"data-slot": "combobox-item-text",
	"data-testid": "combobox-item-text",
	className: e("min-w-0 flex-1", "[&_svg:not([class*=size-])]:size-5", n ? "line-clamp-2" : "whitespace-normal", t),
	...r
})), V = h(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ v(x.ItemIndicator, {
	ref: i,
	"data-slot": "combobox-item-indicator",
	"data-testid": "combobox-item-indicator",
	className: e("flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", "transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0", t),
	...r,
	children: n ?? /* @__PURE__ */ v(u, {})
})), H = h(({ className: t, children: n, description: r, ...i }, a) => /* @__PURE__ */ y(x.Empty, {
	ref: a,
	"data-slot": "combobox-empty",
	"data-testid": "combobox-empty",
	className: e("not-empty:flex not-empty:flex-col not-empty:items-start not-empty:gap-1 not-empty:px-3 not-empty:py-4", t),
	...i,
	children: [r != null && r !== "" && /* @__PURE__ */ v("span", {
		"data-slot": "combobox-empty-description",
		"data-testid": "combobox-empty-description",
		className: "text-text-secondary w-full text-sm",
		children: r
	}), n != null && n !== "" && /* @__PURE__ */ v("span", {
		"data-slot": "combobox-empty-title",
		"data-testid": "combobox-empty-title",
		className: "text-text-primary w-full text-base",
		children: n
	})]
})), U = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Group, {
	ref: r,
	"data-slot": "combobox-group",
	"data-testid": "combobox-group",
	className: e("flex flex-col gap-0", t),
	...n
})), W = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.GroupLabel, {
	ref: r,
	"data-slot": "combobox-group-label",
	"data-testid": "combobox-group-label",
	className: e("text-text-secondary flex w-full items-center justify-center pt-3 text-sm font-normal uppercase", t),
	...n
})), G = h(({ className: t, mode: i = "collapsed", padding: a = 4, onKeyDownCapture: o, onBlur: s, ...c }, l) => {
	let u = i === "fixed", d = u || i === "collapsed" ? "collapsed" : "expanded", f = d === "collapsed", { containerRef: p, contextValue: m } = r({ padding: a }), h = (e) => {
		p.current = e, typeof l == "function" ? l(e) : l && (l.current = e);
	}, g = (e) => {
		f && (e.hasAttribute("data-keyboard-chip-nav") || (e.setAttribute("data-keyboard-chip-nav", ""), e.offsetHeight));
	};
	return /* @__PURE__ */ v(n, {
		value: m,
		children: /* @__PURE__ */ v(x.Chips, {
			...c,
			ref: h,
			"data-slot": "combobox-chips",
			"data-testid": "combobox-chips",
			"data-overflow-mode": d,
			"data-multi-layout": u ? "fixed" : void 0,
			className: e("flex min-w-0 flex-1 items-center gap-1", d === "collapsed" ? "flex-nowrap overflow-hidden" : "flex-wrap", t),
			onKeyDownCapture: (e) => {
				if (f) {
					let t = e.target, n = t?.closest?.("[data-slot=\"combobox-input\"]"), r = t?.closest?.("[data-slot=\"combobox-chip\"]");
					(n || r) && (e.key === "ArrowLeft" || e.key === "ArrowRight" || e.key === "Backspace" || e.key === "Delete") && g(e.currentTarget);
				}
				o?.(e);
			},
			onBlur: (e) => {
				f && !e.currentTarget.contains(e.relatedTarget) && e.currentTarget.removeAttribute("data-keyboard-chip-nav"), s?.(e);
			}
		})
	});
}), K = h(({ className: n, variant: r, render: a, id: o, ...s }, c) => {
	let l = i(o);
	return /* @__PURE__ */ v(x.Chip, {
		render: a ?? (r === "ghost" ? /* @__PURE__ */ v("div", {}) : /* @__PURE__ */ v(t, {
			color: "blue",
			size: "lg"
		})),
		ref: (e) => {
			l.current = e, typeof c == "function" ? c(e) : c && (c.current = e);
		},
		"data-slot": "combobox-chip",
		"data-testid": "combobox-chip",
		"data-variant": r,
		className: e(E({ variant: r }), n),
		...s
	});
});
K.displayName = "ComboboxPrimitive.Chip";
var q = h(({ className: t, variant: n, children: r, ...i }, a) => /* @__PURE__ */ v(x.ChipRemove, {
	ref: a,
	"data-slot": "combobox-chip-remove",
	"data-testid": "combobox-chip-remove",
	"data-variant": n,
	className: e(D({ variant: n }), t),
	...i,
	children: r ?? /* @__PURE__ */ v(f, {})
})), J = h(({ className: t, required: n, ...r }, i) => /* @__PURE__ */ v(x.Label, {
	ref: i,
	"data-slot": "combobox-label",
	"data-testid": "combobox-label",
	"data-required": n || void 0,
	className: e("text-text-secondary data-required:after:text-text-error flex items-start text-base font-medium data-required:after:ml-0.5 data-required:after:content-['*']", t),
	...r
})), Y = h(({ className: t, required: n, htmlFor: r, ...i }, a) => {
	let o = _(C);
	return /* @__PURE__ */ v("label", {
		ref: a,
		htmlFor: r ?? o,
		"data-slot": "combobox-input-label",
		"data-testid": "combobox-input-label",
		"data-required": n || void 0,
		className: e("text-text-secondary data-required:after:text-text-error flex items-start text-base font-medium data-required:after:ml-0.5 data-required:after:content-['*']", t),
		...i
	});
}), X = b("text-base", {
	variants: { tone: {
		default: "text-text-secondary",
		warning: "text-text-warning"
	} },
	defaultVariants: { tone: "default" }
}), Z = h(({ className: t, tone: n, ...r }, i) => /* @__PURE__ */ v("p", {
	ref: i,
	"data-slot": "combobox-description",
	"data-testid": "combobox-description",
	className: e(X({ tone: n }), t),
	...r
}));
Z.displayName = "ComboboxPrimitive.Description";
var oe = h(({ className: t, ...n }, r) => /* @__PURE__ */ v("p", {
	ref: r,
	"data-slot": "combobox-error",
	"data-testid": "combobox-error",
	role: "alert",
	className: e("text-text-error text-base", t),
	...n
}));
oe.displayName = "ComboboxPrimitive.Error";
var se = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Icon, {
	ref: r,
	"data-slot": "combobox-icon",
	"data-testid": "combobox-icon",
	className: e("text-field-icon flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", t),
	...n
})), Q = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Backdrop, {
	ref: r,
	"data-slot": "combobox-backdrop",
	"data-testid": "combobox-backdrop",
	className: e("bg-alpha-gray-alpha-gray-25 fixed inset-0 z-40 opacity-0 transition-opacity data-open:opacity-100", t),
	...n
})), ce = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Status, {
	ref: r,
	"data-slot": "combobox-status",
	"data-testid": "combobox-status",
	className: e("text-text-tertiary px-0.75 py-0.5 text-sm", t),
	...n
})), le = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Row, {
	ref: r,
	"data-slot": "combobox-row",
	"data-testid": "combobox-row",
	className: e("flex", t),
	...n
})), ue = (e) => /* @__PURE__ */ v(x.Collection, {
	"data-slot": "combobox-collection",
	"data-testid": "combobox-collection",
	...e
}), de = h(({ className: t, ...n }, r) => /* @__PURE__ */ v(x.Separator, {
	ref: r,
	"data-slot": "combobox-separator",
	"data-testid": "combobox-separator",
	className: e("bg-border-100 mx-3 h-px shrink-0", t),
	...n
})), fe = h(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ v("span", {
	ref: i,
	"data-slot": "combobox-leading-icon",
	"data-testid": "combobox-leading-icon",
	"aria-hidden": "true",
	className: e("text-text-tertiary inline-flex size-5 shrink-0 items-center justify-center [&>svg]:size-5", t),
	...r,
	children: n
}));
fe.displayName = "ComboboxPrimitive.LeadingIcon";
var pe = h(({ className: t, checked: n = !1, ...r }, i) => /* @__PURE__ */ v(re.Root, {
	className: "contents",
	children: /* @__PURE__ */ v(o.Root, {
		ref: i,
		"data-slot": "combobox-item-checkbox",
		"data-testid": "combobox-item-checkbox",
		checked: n,
		size: "md",
		tabIndex: -1,
		"aria-hidden": !0,
		className: e("pointer-events-none", t),
		...r,
		children: /* @__PURE__ */ v(o.Indicator, { size: "md" })
	})
}));
pe.displayName = "ComboboxPrimitive.ItemCheckbox";
var me = b("inline-flex shrink-0 cursor-pointer items-center gap-0.5 self-center rounded-[48px] px-2 py-1 text-base font-medium select-none group-data-[size=sm]/combobox-group:text-sm", {
	variants: { color: {
		blue: "text-text-link",
		red: "text-palette-error-palette-red-textandicon"
	} },
	defaultVariants: { color: "blue" }
}), he = h(({ className: t, children: n, color: r, onClick: i, onMouseDown: o, ...s }, c) => {
	let { ref: l, overflowCount: u, isOverflowing: d } = a(), f = (e) => {
		l.current = e, typeof c == "function" ? c(e) : c && (c.current = e);
	}, p = (e) => {
		e.stopPropagation(), e.preventBaseUIHandler?.();
	}, m = i != null, h = (e) => {
		let t = e.closest("[data-slot=\"combobox-input-group\"]");
		if (!t || t.hasAttribute("data-disabled")) return;
		let n = t.querySelector("[data-slot=\"combobox-input\"]"), r = t.querySelector("[data-slot=\"combobox-trigger\"]");
		if (t.hasAttribute("data-popup-open")) {
			n?.focus();
			return;
		}
		!r || r.disabled || (r.click(), n?.focus());
	}, g = !d;
	return /* @__PURE__ */ v("span", {
		ref: f,
		"data-slot": "combobox-overflow-badge",
		"data-testid": "combobox-overflow-badge",
		"aria-hidden": g || void 0,
		style: g ? { visibility: "hidden" } : void 0,
		onClick: (e) => {
			if (p(e), m) {
				i?.(e);
				return;
			}
			h(e.currentTarget);
		},
		onMouseDown: (e) => {
			p(e), o?.(e);
		},
		className: e(me({ color: r }), t),
		...s,
		children: n ?? `+${u}`
	});
});
he.displayName = "ComboboxPrimitive.OverflowBadge";
var $ = h(({ className: t, children: n, ...r }, i) => /* @__PURE__ */ v("div", {
	ref: i,
	"data-slot": "combobox-popup-action",
	"data-testid": "combobox-popup-action",
	role: "button",
	tabIndex: -1,
	className: e("border-border-100 text-text-link flex min-h-11 w-full cursor-pointer items-center gap-1.5 rounded-md border-t px-3 py-2.5 text-base font-normal outline-none", "hover:bg-button-ghost-color-hover hover:text-text-link-hover", "data-highlighted:bg-button-ghost-color-hover data-highlighted:text-text-link-hover", t),
	...r,
	children: n ?? /* @__PURE__ */ y(ne, { children: [/* @__PURE__ */ v(d, { className: "size-5" }), "Button"] })
}));
$.displayName = "ComboboxPrimitive.PopupAction", T.displayName = "ComboboxPrimitive.Root", j.displayName = "ComboboxPrimitive.InputGroup", M.displayName = "ComboboxPrimitive.Input", N.displayName = "ComboboxPrimitive.Trigger", P.displayName = "ComboboxPrimitive.Value", F.displayName = "ComboboxPrimitive.Clear", I.displayName = "ComboboxPrimitive.Positioner", L.displayName = "ComboboxPrimitive.Popup", R.displayName = "ComboboxPrimitive.List", z.displayName = "ComboboxPrimitive.Item", B.displayName = "ComboboxPrimitive.ItemText", V.displayName = "ComboboxPrimitive.ItemIndicator", H.displayName = "ComboboxPrimitive.Empty", U.displayName = "ComboboxPrimitive.Group", W.displayName = "ComboboxPrimitive.GroupLabel", G.displayName = "ComboboxPrimitive.Chips", q.displayName = "ComboboxPrimitive.ChipRemove", J.displayName = "ComboboxPrimitive.Label", Y.displayName = "ComboboxPrimitive.InputLabel", se.displayName = "ComboboxPrimitive.Icon", Q.displayName = "ComboboxPrimitive.Backdrop", ce.displayName = "ComboboxPrimitive.Status", le.displayName = "ComboboxPrimitive.Row", ue.displayName = "ComboboxPrimitive.Collection", de.displayName = "ComboboxPrimitive.Separator";
var ge = {
	Root: T,
	Label: J,
	InputLabel: Y,
	Description: Z,
	Error: oe,
	InputGroup: j,
	Input: M,
	Trigger: N,
	Value: P,
	Clear: F,
	Icon: se,
	Portal: ie,
	Backdrop: Q,
	Positioner: I,
	Popup: L,
	List: R,
	Status: ce,
	Empty: H,
	Item: z,
	ItemText: B,
	ItemIndicator: V,
	Group: U,
	GroupLabel: W,
	Row: le,
	Collection: ue,
	VirtualizedList: s,
	Chips: G,
	Chip: K,
	ChipRemove: q,
	Separator: de,
	LeadingIcon: fe,
	ItemCheckbox: pe,
	OverflowBadge: he,
	PopupAction: $,
	useFilter: x.useFilter,
	useFilteredItems: x.useFilteredItems
};
//#endregion
export { ge as ComboboxPrimitive, D as comboboxChipRemoveVariants, E as comboboxChipVariants, X as comboboxDescriptionVariants, k as comboboxFieldTextVariants, O as comboboxInputGroupVariants, ae as comboboxItemVariants, A as comboboxTriggerVisualVariants };
